import type { z } from "zod";

import type { Result } from "@/common/helpers/result";
import { err, ok } from "@/common/helpers/result";

export type InferModelType<T extends { schema: z.ZodType<unknown> }> = z.output<T["schema"]>;

export function createModel<S extends z.ZodType<unknown>>(schema: S) {
  return {
    schema,
    is: (value: unknown): value is z.output<S> => schema.safeParse(value).success,
    from: (value: z.input<S>): z.output<S> => schema.parse(value),
    cast: (value?: unknown): z.output<S> => schema.parse(value),
    safeFrom: (value: z.input<S>): Result<z.output<S>, z.ZodError> => {
      const result = schema.safeParse(value);

      return result.success ? ok(result.data) : err(result.error);
    },
    safeCast: (value?: unknown): Result<z.output<S>, z.ZodError> => {
      const result = schema.safeParse(value);

      return result.success ? ok(result.data) : err(result.error);
    },
  } as const;
}
